import { CommonModule } from '@angular/common';
import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  inject,
} from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  FormArray,
} from '@angular/forms';
import { ProjectsService } from '@/app/services/projects/projects.service';
import { NgToastService } from 'ng-angular-popup';
import { RichTextEditorComponent } from '@/app/components/shared/rich-textEditor/rich-textEditor.component';
import { MatIconModule } from '@angular/material/icon';
import { ProjectTypeComponent } from '@/app/components/projects/project-stages/project-brief/add-project-module/project-type/project-type.component';
import { environment } from '@/app/environments/environment';
import { ProgressService } from '@/app/services/shared/progress.service';
import { SendForApprovalComponent } from '@/app/components/global/dialog-boxes/send-for-approval/send-for-approval.component';
import { MatDialog } from '@angular/material/dialog';
import { TabbedScrollerComponent } from '../../../../tabbed-scroller/tabbed-scroller.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { EventBusService } from '@/app/services/shared/event-bus.service';
import { DialogUtilityService } from '@/app/services/utility/dialog-utility.service';
import { ProgressBarComponent } from '../../../../progress-bar/progress-bar.component';
enum PROJECT_MESSAGES {
  PROJECT_CREATED = 'Project created successfully',
  PROJECT_UPDATED = 'Project updated successfully',
  REQUIRED_FIELDS_MISSING = 'Please fill all the required fields',
  ADDRESS_LOAD_FAILED = 'Failed to load address details',
}

@Component({
  selector: 'app-overview',
  standalone: true,
  imports: [
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    CommonModule,
    ReactiveFormsModule,
    RichTextEditorComponent,
    MatIconModule,
    ProjectTypeComponent,
    ProgressBarComponent,
  ],
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.css'],
})
export class OverviewComponent implements OnInit {
  readonly dialog = inject(MatDialog);
  isLoadingNext = false;
  isLoadingSave = false;
  @Input() isEdit!: boolean;
  @Input() projectId: number | null = null;
  @Output() changeStages: EventEmitter<any> = new EventEmitter<any>();
  @Output() projectIdEmitter = new EventEmitter<number>();
  currentProgress: number;
  projectStartDate: any;
  projectEndDate: any;

  parantProjectTypeName: any;
  childProjectTypeName: any;
  projectTypes: string[] = [];
  editProjectInfo: any;
  grade: any;
  selectedGradeName: any;
  projectTypeParantId: any;
  projectTypeChildId: any;
  keyDeliverables: string[] = [];
  oldKeyDeliverables: any[] = [];
  removedOldKeyDeliverables: string[] = [];
  riskassessment: string[] = [];
  selectedStakeholders: string[] = [];
  propertyGoals: string[] = [];
  selectedImage: string | null = null;
  selectedLocationImage: string | null = null;
  resetRichTextEditor = false;
  resetMapState = false;
  showGMPFields = false;
  showMileStonesField = false;
  showFileError = false;
  projectInfo = '';
  // File state

  formattedValue = '';
  stakeholder: any = '';
  currencyInput = 0;
  currentImageIndex = 0;
  isFetch = false;
  fileName: any;
  form!: FormGroup;

  base_path = environment.storageUrl;
  google_api_key = environment.apiKey;

  amountInWords: any;
  RCamountInWords: any;

  gmpAmountInWords: any;

  deleted_attachments: number[] = [];
  progress = 0;
  storedProgress = 0;
  isStageOneSendForApproval = false;

  customType: any;
  customParentId: any;
  selectedSection = 'section1';
  stage1Progress: any;
  constructor(
    private fb: FormBuilder,
    private projectsService: ProjectsService,
    private toast: NgToastService,
    private progressService: ProgressService,
    private TabbedScrollerComponent: TabbedScrollerComponent,
    private eventBusService: EventBusService,
    private dialogService: DialogUtilityService
  ) {}

  ngOnInit() {
    this.form = this.progressService.getProjectOverviewForm();

    if (this.projectId) {
      this.projectDetail();
      this.fetchCurrentProgress();
    }
    this.progressService.progress$.subscribe((value) => {
      this.stage1Progress = value;
    });
  }

  fetchCurrentProgress() {
    this.currentProgress = this.progressService.getProgressValue();
  }

  toggleGMP($event: Event) {
    const checkbox = $event.target as HTMLInputElement;
    this.showGMPFields = checkbox.checked;
  }
  checkDates(): void {
    const startDate = this.form.get('startdate')?.value;
    const endDate = this.form.get('enddate')?.value;
    this.projectStartDate = startDate;
    this.projectEndDate = endDate;

    // Enable the checkbox only if both start and end dates are set
    if (startDate && endDate) {
      this.form.get('mileStonesCheck')?.enable();
    } else {
      this.form.get('mileStonesCheck')?.disable();
      this.form.get('mileStonesCheck')?.setValue(false); // Uncheck the checkbox if dates are invalid
      this.showMileStonesField = false; // Hide the mileStonesData div
    }
  }

  projectDetail() {
    // console.log('Fetching existance project info');
    this.projectsService.getProjectBriefDetails(this.projectId).subscribe({
      next: (response: any) => {
        console.log('The project Detail is:', response);

        this.editProjectInfo = response;

        if (response?.name) {
          this.form.controls['name']?.setValue(response.name);
        }
        if (response?.project_type) {
          this.form.controls['project_type']?.setValue(response.project_type);
        }

        if (response?.description) {
          this.form.controls['outline']?.setValue(response.description);
        }

        if (response?.projectTypeTree?.[0]?.id) {
          this.projectTypeParantId = response.projectTypeTree[0].id;
          this.parantProjectTypeName = response.projectTypeTree[0].name;
        }
        if (response?.projectTypeTree?.[1]?.id) {
          this.projectTypeChildId = response.projectTypeTree[1].id;
          this.childProjectTypeName = response.projectTypeTree[1].name;
        }
        if (response?.goals) {
          this.oldKeyDeliverables = response?.goals;
        }
      },
      error: (error: any) => {
        console.error('Error fetching the project detail:', error);
      },
    });
  }
  preventSubmit(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault(); // Prevent form submission
    }
  }

  // Function to add a keyDeliverable when "Enter" is pressed
  addKeyDeliverables(): void {
    const value = this.form.get('currentKeyDeliverable')?.value.trim();
    if (!value) {
      return;
    }

    this.keyDeliverables.push(value);
    this.form.get('currentKeyDeliverable')?.reset();
    this.progressService.updateProgressMetrics(
      'keyDeliverables',
      this.keyDeliverables
    );
  }

  removeOldKeyDeliverables(item): void {
    this.oldKeyDeliverables = this.oldKeyDeliverables.filter(
      (deliverable) => deliverable.id !== item.id
    );
    this.removedOldKeyDeliverables.push(item.id);
  }

  // Function to remove a specific keyDeliverable
  removeKeyDeliverables(keyDeliverable: string): void {
    this.keyDeliverables = this.keyDeliverables.filter(
      (item) => item !== keyDeliverable
    );
  }

  updateOutline(value: string) {
    this.form.controls['outline'].setValue(value);
  }

  addProjectType(content: any) {
    this.projectTypeParantId = content;
    this.progressService.updateProgressMetrics('projectTypeParantId', content);
  }

  addProjectSubType(content: any) {
    this.projectTypeChildId = content;
  }

  addProjectOutline(content: string) {
    this.form.controls['outline'].setValue(content);
  }

  addProjectPurpose(content: string) {
    this.form.controls['purpose'].setValue(content);
  }

  addProjectSiteCondition(content: string) {
    this.form.controls['siteconditions'].setValue(content);
  }

  async handleSubmit(action: string) {
    if (this.form.invalid) {
      this.isFetch = true;
      this.toast.warning(
        PROJECT_MESSAGES.REQUIRED_FIELDS_MISSING,
        'WARNING',
        4000
      );
      this.form.markAllAsTouched();
      return;
    }

    if (this.form.valid) {
      if (action === 'next') {
        this.isLoadingNext = true;
      } else {
        this.isLoadingSave = true;
      }
      const dataToSubmit = await this.prepareDataToSubmit();

      if (this.projectId) {
        this.projectsService.updateProjectBrief(dataToSubmit).subscribe({
          next: (response: any) => {
            this.toast.success(
              PROJECT_MESSAGES.PROJECT_UPDATED,
              'SUCCESS',
              4000
            );
            if (action === 'next') {
              this.isLoadingNext = false;
            } else {
              this.isLoadingSave = false;
            }

            this.processProjectAddUpdateResponse(response);
            if (action === 'next') {
              this.TabbedScrollerComponent.nextStep();
            }
          },
          error: (error: any) => {
            if (action === 'next') {
              this.isLoadingNext = false;
            } else {
              this.isLoadingSave = false;
            }
            console.error('Login failed:', error);
            this.toast.danger(error.error.message, 'DANGER', 4000);
          },
        });
      } else {
        this.projectsService.addProjectInfo(dataToSubmit).subscribe({
          next: (response: any) => {
            this.toast.success(
              PROJECT_MESSAGES.PROJECT_CREATED,
              'SUCCESS',
              4000
            );

            // Trigger update for any component that is listening for project creation
            this.eventBusService.triggerProjectCreatedEvent();

            if (action === 'next') {
              this.isLoadingNext = false;
            } else {
              this.isLoadingSave = false;
            }

            this.emitProjectDetails(response.data);
            this.processProjectAddUpdateResponse(response);
            if (action === 'next') {
              this.TabbedScrollerComponent.nextStep();
            }
          },
          error: (error: any) => {
            if (action === 'next') {
              this.isLoadingNext = false;
            } else {
              this.isLoadingSave = false;
            }

            console.error('Login failed:', error);
            this.toast.danger(error.error.message, 'DANGER', 4000);
          },
        });
      }
    } else {
      this.toast.warning(
        PROJECT_MESSAGES.REQUIRED_FIELDS_MISSING,
        'WARNING',
        4000
      );
    }

    this.isFetch = true;
  }
  processProjectAddUpdateResponse(response: any) {
    localStorage.setItem('projectId', response.data.id);
    const stages = {
      stage1: true,
      stage2: false,
      stage3: false,
    };
    localStorage.setItem('stages', JSON.stringify(stages));
    this.changeStages.emit(stages);
    this.isEdit = true;
    this.storedProgress = response.data.stage_one_completion_percentage;
    localStorage.setItem('isEdit', String(true));

    /**
     * make current keyDeliverables as old keyDeliverables
     * so when we save again, we wont save key deliverables again
     */
    if (this.keyDeliverables.length > 0 && response.data.goals) {
      this.oldKeyDeliverables = response.data.goals;
      this.keyDeliverables = [];
      this.removedOldKeyDeliverables = [];
    }
  }

  async prepareDataToSubmit() {
    const dataToSubmit = new FormData();

    // Append non-empty values only
    const appendIfNotEmpty = (key: string, value: any) => {
      if (value !== null && value !== undefined && value !== '') {
        dataToSubmit.append(key, value);
      }
    };

    appendIfNotEmpty('name', this.form.get('name')?.value);

    if (
      this.projectTypeParantId !== 'Custom' &&
      this.projectTypeParantId !== 'custom'
    ) {
      if (this.projectTypeChildId || this.projectTypeParantId) {
        appendIfNotEmpty(
          'project_type_id',
          this.projectTypeChildId || this.projectTypeParantId
        );
      }

      localStorage.setItem('project-name', this.form.get('name')?.value);
    } else {
      try {
        const customData = {
          parent_id:
            this.customParentId !== 'Custom' && this.customParentId !== 'custom'
              ? this.customParentId
              : '',
          name: this.customType,
        };

        const customTypeResponse: any = await this.createCustomProjectType(
          customData
        );

        // console.log('customTypeResponse :',customTypeResponse);

        if (customTypeResponse.id) {
          dataToSubmit.append('project_type_id', customTypeResponse?.id);
        } else {
          dataToSubmit.append('project_type_id', customTypeResponse?.parent_id);
        }
        // console.log('The custom response is:', customTypeResponse);
      } catch (error) {
        console.error('Error creating custom project type:', error);
      }
    }

    appendIfNotEmpty('description', this.form.get('outline')?.value);

    this.keyDeliverables.forEach((keyDeliverable: any) => {
      if (keyDeliverable) {
        dataToSubmit.append('key_deliverables[]', keyDeliverable);
      }
    });

    // If user has removed any old key_deliverable, remove them from backend
    if (this.removedOldKeyDeliverables) {
      this.removedOldKeyDeliverables.forEach((removedKeyDeliverable: any) => {
        dataToSubmit.append(
          'removed_key_deliverables[]',
          removedKeyDeliverable
        );
      });
    }

    // If we are updating, set is_update = true and send project_id
    if (this.projectId) {
      dataToSubmit.append('is_update', 'true');
      dataToSubmit.append('project_id', this.projectId.toString());
    }

    return dataToSubmit;
  }
  createCustomProjectType(customData: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.projectsService.createCustomProjectTypes(customData).subscribe({
        next: (response: any) => {
          // console.log('Raw API response:', response);
          if (response && response.data) {
            // console.log('Resolved data:', response.data);
            resolve(response.data); // Resolve the promise with the actual data
          } else {
            console.error('Invalid response structure:', response);
            reject('Invalid response structure'); // Reject if the response structure is invalid
          }
        },
        error: (error) => {
          console.error('Error in API call:', error);
          reject(error); // Reject the promise with the error
        },
      });
    });
  }
  openDialog() {
    // If progress is 100, open dialogue
    if (this.storedProgress != 100) {
      this.toast.danger(
        'All fields must be filled before sending for approval.',
        'DANGER',
        4000
      );
      return false;
    }

    /**
     * TODO: this needs to be stored in component/state/local storage
     * and will be send to send-for-approval component
     */
    const projectId = localStorage.getItem('projectId');
    if (!projectId) {
      this.toast.danger('Project id not found', 'ERROR');
      return;
    }

    const dialogRef = this.dialog.open(SendForApprovalComponent, {
      // Sending props
      data: {
        progress: this.progress,
        stage: 1,
        projectId: projectId,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result?.success) {
        this.toast.success('Approval sent successfully!', 'SUCCESS', 4000);

        this.isStageOneSendForApproval = true;
        localStorage.setItem('isApproved', 'true');
      }
    });
  }
  customTypeData(content: any) {
    this.customType = content.customType;
    this.customParentId = content.CustomProjectTypeParentId;
  }
  emitProjectDetails(data: any) {
    this.projectId = data.id;
    this.projectIdEmitter.emit(this.projectId);
  }

  private updateProgressMetrics() {
    const totalFields = this.calculateTotalFields();
    const completedFields = this.calculateCompletedFields();

    // Calculate progress as a percentage
    console.log(
      'overview =>> completedFields, totalFields',
      completedFields,
      totalFields
    );
    const progress = (completedFields / totalFields) * 100;
    this.progress = progress;
    this.progressService.updateProgress1(progress);
  }

  private calculateTotalFields(): number {
    let totalFields = this.getMainFormFields().length;

    if (this.form.get('mileStonesCheck')?.value) {
      const mileStonesData = this.form.get('mileStonesData') as FormArray;
      totalFields += mileStonesData.length * 3; // Each group has 3 fields
    }

    if (this.form.get('checkbox')?.value) {
      totalFields += 2; // Adding capbudget and rcbudget
    }

    totalFields += this.getAdditionalFields().length;

    return totalFields;
  }

  private calculateCompletedFields(): number {
    let completedFields = 0;

    // Check main form fields
    this.getMainFormFields().forEach((field) => {
      const value = this.form.get(field)?.value;
      if (this.shouldCountField(field, value)) {
        completedFields++;
      }
    });

    // Check milestones
    if (this.form.get('mileStonesCheck')?.value) {
      const mileStonesData = this.form.get('mileStonesData') as FormArray;
      mileStonesData.controls.forEach((group) => {
        ['name', 'start_date', 'end_date'].forEach((field) => {
          if (group.get(field)?.value) completedFields++;
        });
      });
    }

    // Check budgets
    if (this.form.get('checkbox')?.value) {
      ['capbudget', 'rcbudget'].forEach((field) => {
        if (this.form.get(field)?.value) completedFields++;
      });
    }

    // Check additional fields
    this.getAdditionalFields().forEach((field) => {
      if (field) completedFields++;
    });

    return completedFields;
  }

  private getMainFormFields(): string[] {
    return [
      'name',
      'outline',
      'city',
      'street',
      'zipCode',
      'latitude',
      'longitude',
      'siteconditions',
      'allocated',
      'startdate',
      'enddate',
    ];
  }

  private getAdditionalFields(): boolean[] {
    return [!!this.projectTypeParantId, this.keyDeliverables.length > 0];
  }

  private shouldCountField(field: string, value: any): boolean {
    const tagRegex = /<[^>]*>/g;
    const cleanValue = (value: string): string =>
      value?.replace(tagRegex, '') || '';

    if (field === 'outline' || field === 'siteconditions') {
      return !!cleanValue(value);
    }
    return !!value;
  }
  closeDialog() {
    this.dialogService.closeProjectBriefDialog();
    if (this.form.get('name')?.value) {
      this.handleSubmit('save');
    }
  }
}
